import React, { PropTypes } from 'react';
import { inject, observer } from "mobx-react/index";
import moment from "moment/moment";
import { action, autorun, observable, toJS } from "mobx";
import Form, { CheckBoxInput, DateInput, FormActions, FormBody } from "../../Form";
import Spinner from "../../Spinner";
import StationFullObservationTable from "./StationFullObservationTable";
import StationFullObservationGraph from "./StationFullObservationGraph";
import _ from 'lodash';

@inject('stationStore', 'dataSeriesStore', 'parameterStore', 'uiStore', 'tagStore')
@observer
class StationFullObservation extends React.Component {

  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props)
    this.state = {
      cableLength: ''
    }
  }

  @observable isLoading = false;
  @observable pinGraph = false;
  @observable showQC = false;
  @observable filters = {
    date_from: moment().add(-3, 'months').format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),
    tag_id: null
  };

  @observable stationId;
  @observable tags = [];
  dispose;

  componentWillMount() {
    const { params: { id }, stationStore, tagStore } = this.props;
    if (!tagStore.items.length && !tagStore.isLoading) tagStore.fetchItems();
    let station = stationStore.findById(id);

    if (station && station.meta_data) {
        const cableData = station.meta_data.find((item) => item.name.toLowerCase().startsWith('logger cable')) 
        const cableLength = cableData ? cableData.value : ''
        this.setState({cableLength})
    }

    this.dispose = autorun(() => {
      if (!!tagStore.items.length) {
        this.tags = station.tags.filter(tag => {
          const tagItem = tagStore.findById(tag.id);
          return !!tagItem && !!tagItem.parameters && !!tagItem.parameters.length;
        });
      }
    })
    this.filters.tag_id = _.get(station, 'tags[0].id', null);
    this.stationId = id;
    this.showObservations();
    
  }

  componentWillUnmount() {
    if (!!this.dispose) this.dispose();
  }

  componentWillReceiveProps(nextProps) {
    const { params: { id }, stationStore } = nextProps;
    let station = stationStore.findById(id);
    this.filters.tag_id = _.get(station, 'tags[0].id', null);
    this.stationId = id;
    this.showObservations();
  }


  @action onChangeDateFrom = (e) => this.filters.date_from = e.target.value;
  @action onChangeDateTo = (e) => this.filters.date_to = e.target.value;
  @action onChangeTag = (id) => {
    this.filters.tag_id = id;
    this.showObservations();
  }
  @action onChangeShowQC = e => this.showQC = !this.showQC;
  @action onChangePinGraph = e => this.pinGraph = !this.pinGraph;

  showObservations = e => {
    e && e.preventDefault();

    const { stationStore } = this.props;
    const { date_from, date_to, tag_id } = this.filters;

    if (!tag_id) return;

    stationStore.fetchFullObservations({
      stations: [this.stationId],
      date_from,
      date_to,
      show_qc: true,
      use_tag: true,
      tag_id
    }).catch((err) => {
      this.context.notify.error({ message: err.message || err.toString() });
    })
  };

  toggleParameterShow = id => {
    let parameter = this.props.stationStore.stationFullObservation.parameters.find(item => +item.id === +id);
    if (!!parameter) parameter.show = !parameter.show;
  };

  render() {
    const { stationStore, uiStore } = this.props;
    const {cableLength} = this.state

    let stationFullObservation = stationStore.stationFullObservation.station_id === this.stationId ? stationStore.stationFullObservation : null;

    return (
      <div style={this.pinGraph ? { position: 'absolute', margin: '0 -15px', padding: '0 15px', background: 'white', width: `calc(100vw - 64px - ${uiStore.navWidth})` } : {}}>
        <div className='TabBar TabBarRounded'>
          <ul>
            {this.tags.map(tag => (
              <li key={`tag-${tag.id}`} onClick={() => this.onChangeTag(tag.id)}
                className={+this.filters.tag_id === +tag.id ? 'active' : ''}>
                <a>{tag.name}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
            {stationFullObservation && stationFullObservation.data && stationFullObservation.data.length ?
            <div>
                <StationFullObservationGraph
            onChangePinGraph={this.onChangePinGraph}
            pinGraph={this.pinGraph}
            stationObservation={Object.assign([], toJS(stationFullObservation.data))}
            parameters={stationFullObservation.parameters}
            cableLength={cableLength}
          />
            
            <div style={{fontSize:'13px', fontWeight:'bold'}}>
            {cableLength ? `Logger Cable Length : ${cableLength}m` : ''}
             </div>
              </div>          
          : null}        
        </div>
        
        <Form>
          <FormBody className='formBody'>
            <div className='inline-grid v-center' style={{ gap: '0'}}>
              <DateInput
                label={'Date From'}
                value={this.filters.date_from}
                onChange={this.onChangeDateFrom}
              />
              <DateInput
                label={'Date To'}
                value={this.filters.date_to}
                onChange={this.onChangeDateTo}
              />
              <CheckBoxInput label='QC' checked={this.showQC} onChange={this.onChangeShowQC} />
              <span className='flex-grow' />
              <button onClick={this.showObservations}>View</button>
            </div>
            {/*{<button onClick={this.exportCSV}>Download CSV <span style={{fontSize: '12px'}}>({timezone}{timezone !== 'UTC' && ' ' + moment.tz(timezone).zoneAbbr()})</span></button>}*/}
          </FormBody>
        </Form>
        {stationStore.isLoading && <Spinner />}
        {stationFullObservation && stationFullObservation.data && stationFullObservation.data.length ? <StationFullObservationTable pinGraph={this.pinGraph} stationObservation={Object.assign([], toJS(stationFullObservation.data))} parameters={stationFullObservation.parameters} toggleParameterShow={this.toggleParameterShow} showQC={this.showQC} /> : null}
      </div>
    );
  }
}

export default StationFullObservation;


// WEBPACK FOOTER //
// ./src/components/Station/FullObservation/StationFullObservation.js